import React, { Component } from 'react';
import FlipMove from 'react-flip-move';
import { Waypoint } from 'react-waypoint';
import { connect } from 'react-redux';
import { itemSelector, userSelector } from '../redux/selectors'
import { toArray } from '../common/util';
import { fetchItems } from '../redux/actions';
import { Link } from 'react-router-dom';

class DKPItems extends Component {
    constructor(props) {
        super(props);
        this.handleUpdate= this.handleUpdate.bind(this);
    }

    componentDidMount() {
        this.props.getItems(this.props.chapter.id)
    }

    handleUpdate() {
        if (!this.props.items.pending && this.props.items.more) {
            this.props.getItems(this.props.chapter.id, this.props.items.page)
        }
    }

    render() {
        const itemItems = toArray(this.props.items.data)
            .filter((item) => item.game === this.props.chapter.game.id)
            .sort((a, b) => b.id - a.id)
            .map((item) => (
            <div key={`${item.id}-item`} className="panel-adt">
                <Link to={"/dkp/items/"+item.slug}><h5>{item.title}</h5></Link>
            </div>
        ));
        return (
            <div>
                <h1>{this.props.chapter.game.title} Item History</h1>
                <FlipMove
                    staggerDelayBy={50}
                    appearAnimation="fade"
                    enterAnimation="fade"
                    leaveAnimation="fade"
                    className="news"
                >
                    {itemItems}
                </FlipMove>
                <div>
                    <Waypoint
                        key="waypoint"
                        onEnter={this.handleUpdate}
                        bottomOffset='-10%'
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    items: itemSelector(state),
    users: userSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
     getItems: (chapter, section, page) => dispatch(fetchItems(chapter, section, page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DKPItems);


// WEBPACK FOOTER //
// ./src/DKP/DKPItems.js